import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../components/Tooltip';
import { EmailIcon } from '../../components/svgs/icons/EmailIcon';
import { MessageSquareIcon } from '../../components/svgs/icons/MessageSquare';
import { styleSheet } from './styles';

interface TemplateCounterpartTagProps {
	label: string;
	onClick?(e: React.MouseEvent<Element>): void;
	styles?: StyleDeclarationValue[];
}

export const TemplateCounterpartTag: React.FC<TemplateCounterpartTagProps> = ({ label, onClick, styles = [] }) => {
	return (
		<Tooltip>
			<TooltipTrigger aria-label={label} className={css(styleSheet.tag, ...styles)} onClick={onClick}>
				<MessageSquareIcon />
				<span>+</span>
				<EmailIcon fillColor='currentColor' />
			</TooltipTrigger>
			<TooltipContent styles={[styleSheet.tooltipContent]}>{`${label}.`}</TooltipContent>
		</Tooltip>
	);
};
